export default {
	STAFF: 1,
    SUPPLIER: 2,
    CONTRACTOR: 3,
	OTHER: 4,
}

export const EmploymentTypeTitle = {
	1: "کارکنان",
    2: "تامین کنندگان",
    3: "پیمانکاران",
	4: "سایر",
};